import { STATUS } from '@type/db-types';
import { Tag } from 'antd';
import { log } from '@utils/logging';

export function PublicationStatusChip(status: STATUS | null) {
    if (!status) return null;

    switch (status) {
        case STATUS.ACTIVE:
            return <Tag color="success">Published</Tag>;
        case STATUS.PENDING:
            return <Tag color="warning">Waiting</Tag>;
        case STATUS.CANCELLED || STATUS.DECLINED:
            return <Tag color="error">{status}</Tag>;
        case STATUS.INVITED:
            return <Tag color="info">{status}</Tag>;

        default:
            log(`unrecognized membership status: ${status}`);

            return null;
    }
}
